
import { LocalStorage } from '../components/common/storage';
const store = new LocalStorage('spacex')
interface ucapi {
    invoke: Function
}
const SCENE_ID = 12;//场景ID, CMS固定值

// 从spacex平台获取slotid
export function getAbSlotid(key, callback) {


    const storeKey = store.getItem(`spacex/ad/${key}`)
    const storeTime = store.getItem(`spacex/ad/update_time`) || Date.now()

    let hasCallback = false

    function cb(value) {
        store.setItem(`spacex/ad/${key}`, value || '');
        store.setItem(`spacex/ad/update_time`, Date.now())

        if (!hasCallback) {
            hasCallback = true
            callback(value)
        }
    }

    if (!key) {
        return callback('')
    }

    // 一个小时之内 则直接返回缓存值
    if (storeKey && (Date.now() - <number>storeTime < 3600000)) {
        cb(storeKey)
    }

    const ucapi: ucapi = window.ucapi
    if (ucapi && ucapi.invoke) {
        ucapi.invoke('spacex.getExpsParamForSceneId', {
            sceneId: SCENE_ID,
            success: function (data) {
                var expsParam: any = {}
                var adMap = {}
                if (data && data.expsParam) {
                    expsParam = mapToJson(data.expsParam);
                }
                if (expsParam && expsParam.iflow_ad_slotid) {
                    const array = expsParam.iflow_ad_slotid.split(';')
                    for (var i = 0; i < array.length; i++) {
                        const n = array[i].split(':');
                        adMap[n[0]] = n[1]
                    }
                } else {
                    cb('')
                }
                cb(adMap[key])
            },
            fail: function () {
                cb('')
            }
        })
    } else {
        cb('')
    }


}

function mapToJson(str) {
    if (!str || str == "{}") {
        return {}
    }
    str = str.substring(1, str.length - 1)

    var array = str.split(', ');
    var map = {}
    for (var i = 0; i < array.length; i++) {
        var tmp = array[i].match(/([^=]*)=(.*)/)
        if (tmp) {
            map[tmp[1]] = tmp[2]
        }
    }
    return map
}